import { Icon } from '@components/icon/Icon';
import typography from '~styles/typography.scss';
import styles from './TableList.scss';
import { FloorPlanIcons } from '@components/icon/FloorPlanIcons';

interface Table {
  id: string;
  iconName: string;
  name: string;
}

interface TableListProps {
  tables: Table[];
}

export const TableList = ({ tables }: TableListProps) => (
  <ul className={styles.tableList} data-testid="table-list">
    {tables.map((table) => (
      <li key={table.id}>
        <FloorPlanIcons name={table.iconName} />
        <div className={typography.t2}>{table.name}</div>
      </li>
    ))}
  </ul>
);
